import { render, staticRenderFns } from "./ListFilesFase2.vue?vue&type=template&id=336032b5&scoped=true"
import script from "./ListFilesFase2.vue?vue&type=script&lang=js"
export * from "./ListFilesFase2.vue?vue&type=script&lang=js"
import style0 from "./ListFilesFase2.vue?vue&type=style&index=0&id=336032b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336032b5",
  null
  
)

export default component.exports